module.exports = __webpack_public_path__ + "c82718a8df6eb332dad821f231e4cec2.pdf";